/* @flow */

import Immutable from 'immutable';

function pureReducer(reducer: Function): Function {
  return (state: Immutable.Map, action: Object): Immutable.Map => {
    var newState = reducer(state, action);
    if (newState.equals(state)) {
      return state;
    } else {
      return newState;
    }
  };
}

export { pureReducer };
